import qs from "qs";
import * as axiosHelper from "./api_helper";

export const getEvents = async ({ payload }) => {
  const data = await axiosHelper.get(`/events?${qs.stringify(payload)}`);
  return data.result;
};

export const getEventFilterOptions = async () => {
  const data = await axiosHelper.get("/events/filters");
  return data.result;
};
